module.exports = __webpack_public_path__ + "static/media/lds-logo_hy.c17b8e93.svg";